import React from "react";

import { StyledList, StyledListProps } from "./styles";

export const List: React.FC<StyledListProps> = ({ children, ...rest }) => (
  <StyledList {...rest}>{children}</StyledList>
);
